import { TrendingUp } from "lucide-react";
import { RecentSpike } from "@/lib/api";
import HoverPopover from "@/components/ui/HoverPopover";

interface Props {
  spikes: RecentSpike[];
}

function formatQty(n: number): string {
  return Math.round(n).toLocaleString('de-DE');
}

function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}

export default function RecentSpikesTooltip({ spikes }: Props) {
  if (!spikes || spikes.length === 0) {
    return null;
  }

  const sorted = [...spikes].sort((a, b) => b.date.localeCompare(a.date));

  return (
    <HoverPopover
      trigger={
        <TrendingUp className="h-3.5 w-3.5 text-risk-yellow hover:text-risk-yellow/80 cursor-help" />
      }
      panelClassName="w-[28rem] max-w-[92vw] rounded-card border border-line bg-surface p-3 text-left"
    >
      <span className="block font-mono text-[10px] font-medium uppercase tracking-[0.06em] text-ink-soft mb-1">
        Erkannte Bedarfs-Spitzen
      </span>
      <span className="block text-[11px] text-ink-soft mb-2">
        Ausreißer-Bestellungen, die bei der Tages-Bedarfs-Berechnung auf einen robusten Schwellwert gekappt wurden. Verhindert, dass einmalige Großbestellungen die Baseline verzerren.
      </span>
      <table className="w-full text-xs border-separate border-spacing-x-4 border-spacing-y-0">
        <colgroup>
          <col className="w-24" />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr className="text-ink-soft">
            <th className="text-left font-medium pb-1">Datum</th>
            <th className="text-right font-medium pb-1">Tatsächlich</th>
            <th className="text-right font-medium pb-1">Gekappt auf</th>
          </tr>
        </thead>
        <tbody className="text-ink-muted">
          {sorted.map((spike) => (
            <tr key={spike.date} className="align-top">
              <td className="py-1 tabular-nums border-t border-surface-3">{formatDate(spike.date)}</td>
              <td className="py-1 text-right tabular-nums font-semibold border-t border-surface-3">{formatQty(spike.originalQty)}</td>
              <td className="py-1 text-right tabular-nums text-ink-soft border-t border-surface-3">{formatQty(spike.cappedQty)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </HoverPopover>
  );
}
